module.exports = __webpack_public_path__ + "img/icb-del-novice-e@3x.24810bf1.png";